import { AxiosRequestHeaders } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

import { GetFileResponse, IGetFileRequest } from 'interfaces/ApiType/apiType';

import { publicApi } from './index';

export const getFileAPI = async (
  request: IGetFileRequest
): Promise<GetFileResponse | null> => {
  const headers: AxiosRequestHeaders = {};
  if (typeof window !== 'undefined' && localStorage.getItem('token') !== null) {
    headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
  }
  return new Promise((resolve) => {
    publicApi
      .get(`/file/${request.fileId}`, {
        headers,
      })
      .then((data) => resolve(data))
      .catch((e) => {
        resolve(e.response);
      });
  });
};

export const useFileAPI = ({
  fileId,
  ...options
}: IGetFileRequest & UseQueryOptions<GetFileResponse | null>) => {
  return useQuery<GetFileResponse | null, unknown>(
    ['file', fileId],
    () => getFileAPI({ fileId }),
    options
  );
};
